export const INVOICES_ORDER_BY = [
  'buyer_id',
  'buyer_name',
  'date',
  'datetime_parsed',
  'invoice_nr',
  'seller_id',
  'seller_name',
] as const;

export const INVOICES_DIRECTION = ['incoming', 'outgoing'] as const;
